import { Link } from "react-router-dom";
import { topics } from "@/mocks/news";

export default function TopicSection() {
  return (
    <section id="topics" aria-label="瓜情专题" className="w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div>
            <p className="text-xs font-label text-primary-600 tracking-widest mb-2">TOPICS</p>
            <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">
              瓜情专题合集
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md">
            把同一事件的零散动态收进一个专题，按时间顺序排好，随时回看不会漏掉关键节点。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {topics.map((topic) => (
            <Link
              key={topic.slug}
              to={`/dispatch/${topic.slug}`}
              className="group relative block rounded-lg overflow-hidden border border-background-200 cursor-pointer"
            >
              <div className="w-full h-56 md:h-64">
                <img
                  src={topic.image}
                  alt={`${topic.title} 专题封面`}
                  title={`${topic.title} 专题 - 瓜田速递`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/35 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-5">
                <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-accent-500 text-accent-950 text-[11px] font-label font-bold">
                  {topic.count} 条瓜情
                </span>
                <h3 className="mt-2 font-heading text-lg font-bold text-background-50">{topic.title}</h3>
                <p className="mt-1.5 text-xs text-background-100/80 leading-relaxed line-clamp-2">
                  {topic.desc}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}